import React from "react";
import { KeyRound, X } from "lucide-react";
import { isOwnerMode, setOwnerMode, useSubscription } from "../../lib/subscription";

/**
 * OwnerModeBanner
 * -------------------------------------------------------------
 * Thin pill shown at the very top of `/app` when the account
 * owner has enabled "preview as owner" mode from /admin. It
 * makes it obvious that the paywall is being bypassed AND gives
 * a one-tap way to exit owner mode.
 *
 * Renders nothing when owner mode is off.
 */
export const OwnerModeBanner = () => {
  // Re-render when subscription state changes (owner mode dispatches the same event)
  useSubscription();

  if (!isOwnerMode()) return null;

  return (
    <div
      data-testid="owner-mode-banner"
      className="border-b border-[#FFB020]/35 bg-[#FFB020]/10 backdrop-blur-md"
    >
      <div className="max-w-3xl mx-auto px-3 py-1.5 flex items-center gap-2">
        <div
          className="w-6 h-6 rounded-md flex items-center justify-center shrink-0"
          style={{ background: "rgba(255,176,32,0.15)", border: "1px solid rgba(255,176,32,0.45)" }}
          aria-hidden="true"
        >
          <KeyRound className="w-3 h-3" style={{ color: "#FFB020" }} strokeWidth={2.4} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[11px] font-semibold text-white leading-tight">
            Owner preview mode — paywall bypassed
          </div>
          <div className="font-mono text-[9px] uppercase tracking-[0.14em] text-zinc-400 leading-tight">
            Only visible to you. Tap "Exit" to return to the paid gate.
          </div>
        </div>
        <button
          type="button"
          onClick={() => setOwnerMode(false)}
          data-testid="owner-mode-exit"
          className="shrink-0 text-[10px] font-mono uppercase tracking-[0.14em] text-[#FFB020] hover:text-white transition-colors px-2 py-1 rounded-full border border-[#FFB020]/40 hover:border-white/40 inline-flex items-center gap-1"
        >
          <X className="w-3 h-3" strokeWidth={2.4} aria-hidden="true" />
          Exit
        </button>
      </div>
    </div>
  );
};
